import React from 'react';
import SocialShareButton from './SocialShareButton';

function generateHref(type, url) {
  switch (type) {
    case 'facebook': {
      return `https://www.facebook.com/sharer/sharer.php?u=${url}`;
    }
    case 'X': {
      return `https://x.com/intent/tweet?url=${url}%2F`;
    }
    case 'linkedin': {
      return `https://www.linkedin.com/shareArticle?mini=true&&url=${url}`;
    }
    default: {
      return null;
    }
  }
}

const SocialShareWrapper = ({
  config,
  data,
  buttonTypesArray,
  shareUrl,
  tourId,
  tourName,
}) => (
  <div className="share-social-media__container">
    <p className="share-title">Share link on:</p>
    <div className="social-media-buttons">
      {buttonTypesArray.map(type => {
        const href = generateHref(type, shareUrl);
        return <SocialShareButton key={type} type={type} href={href} />;
      })}
    </div>
  </div>
);

export default SocialShareWrapper;
